// @ts-ignore
import objectFitImages from 'object-fit-images';

const objFitSeletor = '[data-ref="object-fit"]';

objectFitImages(objFitSeletor);


